var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loginh5" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/h5/img_pc.png"), alt: "" },
      }),
      _c("p", [_vm._v("请使用PC打开此链接，手机暂不支持。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }